export default __webpack_public_path__ + "static/041-0bec09c04e281edfce21b23930942da0.png";